import React from 'react';
import { Col, Row } from 'elmo-elements';
import { Hours, StaffOnTime } from './components';

const OverviewView = () => {
  return (
    <Row isNoGutters={false} role="presentation">
      <Col className="demo-gird-col" md={16} role="presentation">
        <Hours />
      </Col>
      <Col className="demo-gird-col" md={8} role="presentation">
        <StaffOnTime />
      </Col>
    </Row>
  );
};

export default OverviewView;
